import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  variant?: 'full' | 'text-only';
  className?: string;
}

export default function Logo({ variant = 'full', className = '' }: LogoProps) {
  return (
    <Link to="/" className={`flex items-center transition-opacity hover:opacity-90 ${className}`} data-id="clyvpmgw2" data-path="src/components/navigation/Logo.tsx">
      {variant === 'full' ?
      <div className="flex items-center gap-3" data-id="1e0e49bo5" data-path="src/components/navigation/Logo.tsx">
          <div className="relative" data-id="xza5fkinl" data-path="src/components/navigation/Logo.tsx">
            <img
            src="https://cdn.ezsite.ai/AutoDev/28385/d6cd3f9e-507c-43c9-9d8b-a268a9fe4594.png"
            alt="Bot Lab HQ Logo"
            className="h-12 w-auto flex-shrink-0 rounded-lg shadow-sm" data-id="egnuzozy6" data-path="src/components/navigation/Logo.tsx" />

          </div>
          <div className="flex flex-col" data-id="6aim948p3" data-path="src/components/navigation/Logo.tsx">
            <span className="text-xl font-bold bg-gradient-to-r from-indigo-600 to-violet-600 bg-clip-text text-transparent leading-tight" data-id="6guvnlu0v" data-path="src/components/navigation/Logo.tsx">
              BotLabHQ
            </span>
            <span className="text-xs text-gray-500 font-medium -mt-1" data-id="dp0wcdew5" data-path="src/components/navigation/Logo.tsx">
              AI Solutions
            </span>
          </div>
        </div> :

      <span className="text-xl font-bold bg-gradient-to-r from-indigo-600 to-violet-600 bg-clip-text text-transparent" data-id="qlnotoxn0" data-path="src/components/navigation/Logo.tsx">
          Bot Lab HQ
        </span>
      }
    </Link>);

}